import React from "react";

function Page3() {
  return (
    <div id="page3" className="page">
      <div className="description">
        <div className="inner">
          <div className="texts">
            <div className="background" />
            <p>Zignal curates focused<br/>intelligence feeds with advanced</p>
            <h2 className="outline outline--small">geospatial<br />analysis</h2>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Page3;
